<template>
  <div class="container-fluid">
    <page-header
      class="page-header__extended"
      :page="page"
      :actions="headerActionConfig"
      left-side-class="col-md-8 page-header__extended--left-side"
      right-side-class="
        col-md-4 d-flex align-items-end justify-content-end mb-2
      "
    />
    <filter-manager
      v-model="filter.model"
      class="filter-manager_extended"
      search-container-class="search-btn"
      :filters="filtersConfig"
      :display-advanced="false"
      @application="getModules"
      @module="getLinks"
      @search="onSearchHandler"
    />
    <custom-separator class="my-4" text="Resultado de Guías o Videos" />
    <template v-if="results.length">
      <result-row
        v-for="(result, index) in results"
        :key="`row-${index}`"
        class="mb-3"
        :data="result"
        @enter-clicked="goToAddEditView"
        @watch-video="openVideoHandler"
        @download-guide="downloadGuideHandler"
      />
      <pagination
        v-if="this.pagination.totalItemCount > pageSize"
        :data="pagination"
        show-text
        @pagination-go-page="goToPageHandler"
      />
    </template>
    <custom-result-not-found v-else />
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import FilterManager from "FilterManager";
import Pagination from "pagination";
import CustomSeparator from "custom-separator";
import CustomResultNotFound from "custom-result-not-found";
import ResultRow from "@/views/operations/guidesAndVideos/components/ResultRow.vue";
import {
  getApplications as _getApplications,
  getModules as _getModules,
  getLinks as _getLinks
} from "@/modules/common/code.api.js";
import { getGuides } from "@/modules/guide-video/api";
import _generalService from "@/services/pei/general";
import { cardsbymodule as _cardsByModule } from "@/services/operations/dashboard-management";
const DEFAULT_PAGE_SIZE = 10;

export default {
  name: "MainGuidesAndVideos",
  components: {
    PageHeader,
    FilterManager,
    Pagination,
    CustomSeparator,
    CustomResultNotFound,
    ResultRow
  },
  data: () => ({
    filter: {
      model: {},
      options: {
        apps: [],
        modules: [],
        links: []
      }
    },
    page: {
      icon: "fas fa-calculator",
      title: "Configuración de Guías o Videos"
    },
    pagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: 0
    },
    pageSize: DEFAULT_PAGE_SIZE,
    results: []
  }),
  computed: {
    headerActionConfig() {
      return [
        {
          text: "Regresar",
          icon: "fas fa-arrow-circle-left",
          variant: "outline-success",
          click: () => this.$router.go(-1)
        },
        {
          text: "Añadir",
          icon: "fas fa-file-plus",
          variant: "success",
          click: () => this.goToAddEditView()
        }
      ];
    },
    filtersConfig() {
      return [
        {
          name: "application",
          component: "CustomDropDown",
          options: this.filter.options.apps,
          placeholder: "Aplicación",
          fieldName: "name",
          fieldKey: "keyId",
          class: "col-12 col-md-3",
          clearable: true
        },
        {
          name: "module",
          component: "CustomDropDown",
          options: this.filter.options.modules,
          disabled: this.filter.options.modules.length === 0,
          placeholder: "Módulo",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-3",
          clearable: true
        },
        {
          name: "link",
          component: "CustomDropDown",
          options: this.filter.options.links,
          disabled: this.filter.options.links.length === 0,
          placeholder: "Enlace",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-3",
          clearable: true
        },
        {
          name: "description",
          component: "CustomInput",
          icon: "fa fa-search color-orange",
          leftIcon: true,
          placeholder: "Escriba Descripción",
          class: "col-12 col-md-3"
        }
      ];
    }
  },
  async created() {
    await Promise.all([this.getApplications(), this.onSearchHandler()]);
  },
  methods: {
    async getApplications() {
      const { data } = await _getApplications();
      this.filter.options.apps = [...data];
    },
    async getModules(application) {
      this.filter = {
        options: {
          ...this.filter.options,
          modules: [],
          links: []
        },
        model: {
          ...this.filter.model,
          module: null,
          link: null
        }
      };
      if (!application) return;

      const { data } = await _getModules(application.keyId);
      this.filter.options.modules = [...data];
    },
    async getLinks(module) {
      this.filter.options.links = [];
      this.filter.model.link = null;
      if (!module) return;

      const { data } = await _cardsByModule(module.id, this.filter.model.application?.keyId);
      this.filter.options.links = [...data];
    },
    async goToPageHandler(page) {
      this.pagination.currentPage = page;
      await this.onSearchHandler();
    },
    async onSearchHandler() {
      const params = {
        applicationId: this.filter.model.application?.keyId,
        moduleId: this.filter.model.module?.id,
        linkId: this.filter.model.link?.id,
        description: this.filter.model.description
      };
      const { data: res } = await getGuides(
        params,
        this.pagination.currentPage,
        this.pageSize
      );
      this.results = [...res.data];
      this.pagination = {
        totalItemCount: res.totalItemCount,
        pageCount: res.pageCount,
        currentPage: res.currentPage,
        count: res.count
      };
    },
    goToAddEditView(id) {
      this.$router.push({ name: "manageGuidesAndVideos", params: { id } });
    },
    openVideoHandler(videoUrl) {
      window.open(videoUrl, "_blank");
    },
    downloadGuideHandler(documentId) {
      _generalService.getDocument(documentId);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .page-header__extended {
    &--left-side {
      .tag-badge {
        margin-bottom: 1rem;
      }
      .controls-wrap {
        display: none;
      }
    }
  }
  .filter-manager_extended {
    border-radius: 0.25rem;
    @media only screen and (min-width: 750px) {
      .search-btn {
        &.col-lg-3 {
          flex: 0 0 10%;
          max-width: 10%;
          padding-left: 0;
        }
      }
    }
  }
}
</style>
